export default {
  name: 'marking--orderP',
  apiService: 'shoes',
  apiPath: '/admin/order_p',
};